import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut } from './utils'

export const getPaymentCheck = (projectVersionId) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/review/paymentcheck`
  return doGet(url)
}

export const savePaymentCheck = (projectVersionId, request = {}) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/review/paymentcheck`
  return doPost(url, request)
}

export const savePaymentCheckForceCommit = (projectVersionId, forceCommit) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/budget/grant?forceCommit=${forceCommit ? "Y" : "N"}`
  return doPost(url)
}

// ---------------------------------- subproject
export const getPaymentCheckSubProject = (projectVersionId) => {
  // /api/subproject/{projectVersionId}/payment
  const url = `${API_ROOT}/subproject/${projectVersionId}/payment`
  return doGet(url)
}
// ----------------------------------
